import { useCallback, useState } from 'react';
import { t } from '@bg-shared';

type IError = Error & { status?: number };

interface IState {
    error: string;
    handleError(error: IError): void;
}

export const useHandleError = (): IState => {
    const [error, setError] = useState<string>(null);

    const handleError = useCallback((err: IError) => {
        console.error(err);

        let errorMessage: string;

        if (err?.message) {
            errorMessage = t.string(err.message);
        } else if (err?.status === 500) {
            errorMessage = t.string('something_wrong');
        }

        setError(errorMessage);
    }, []);

    return { error, handleError };
};
